export default "__VITE_ASSET__DblGgq6Q__"